import { Outlet, createRootRoute, createRoute, createRouter } from '@tanstack/react-router'
import { AdminCataloguePage } from './pages/AdminCataloguePage.tsx'
import { AdminMembersPage } from './pages/AdminMembersPage.tsx'
import { AdminPage } from './pages/AdminPage.tsx'
import { BankImportPage } from './pages/BankImportPage.tsx'
import { FineImportPage } from './pages/FineImportPage.tsx'
import { ForgotPinPage } from './pages/ForgotPinPage.tsx'
import { GuestDetailPage } from './pages/GuestDetailPage.tsx'
import { LoginPage } from './pages/LoginPage.tsx'
import { MyTabPage } from './pages/MyTabPage.tsx'
import { OrderPage } from './pages/OrderPage.tsx'
import { PendingApprovalPage } from './pages/PendingApprovalPage.tsx'
import { UserDetailPage } from './pages/UserDetailPage.tsx'
import { IndexRedirect } from './pages/guards.tsx'

const rootRoute = createRootRoute({ component: () => <Outlet /> })

const routeTree = rootRoute.addChildren([
  createRoute({ getParentRoute: () => rootRoute, path: '/', component: IndexRedirect }),
  createRoute({ getParentRoute: () => rootRoute, path: '/login', component: LoginPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/forgot-pin', component: ForgotPinPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/pending-approval', component: PendingApprovalPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/order', component: OrderPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/me', component: MyTabPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/admin', component: AdminPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/admin/members', component: AdminMembersPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/admin/drinks', component: AdminCataloguePage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/admin/fees/import', component: FineImportPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/admin/bank-import', component: BankImportPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/users/$userId', component: UserDetailPage }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/users/$userId/guests/$guestId',
    component: GuestDetailPage,
  }),
])

export const router = createRouter({ routeTree, defaultPreload: 'intent' })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
